import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class SocialService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  listPage(tenantId?: any) {
    return this.getServer('/omap/pages?tenant_id=' + tenantId);
  }
  listPageV2(query?: any) {
    return this.get('/v2/social/pages', query);
  }

  addPage(body: any) {
    return this.postServer('/omap/pages', body);
  }

  addPageV2(body: any) {
    return this.postServer('/v2/facebook/add-page', body);
  }

  updatePage(body: any, page_id) {
    return this.putServer('/omap/pages' + page_id, body);
  }

  findPage(page_id) {
    return this.getServer('/omap/pages/' + page_id);
  }

  deletePage(page_id) {
    return this.deleteServer('/omap/pages/' + page_id);
  }

  deletePageV2(page_id) {
    return this.deleteServer('/v2/facebook/pages/' + page_id);
  }
  // facebook api
  loginFacebookSuccess(accessToken, state, userId) {
    return this.get('/v2/facebook/login-success?access_token=' + accessToken + '&state=' + state + '&userId=' + userId);
  }
  loginZaloSuccess(query?: any) {
    return this.get('/v2/zalo/login-success' + query);
  }

  listZnsTemplate(query?: any) {
    return this.get('/v2/zalo/zns/templates', query);
  }
  createZnsTemplate(body) {
    return this.post('/v2/zalo/zns/template', body);
  }
  getZnsTemplate(id) {
    return this.get('/v2/zalo/zns/template/' + id);
  }
  getZnsTemplateByOa(id) {
    return this.get('/v2/zalo/zns/template/getByOa/' + id);
  }
  updateZnsTemplate(id, body) {
    return this.put('/v2/zalo/zns/template/' + id, body);
  }
  deleteZnsTemplate(body) {
    return this.post('/v2/zalo/zns/template/deleteMany', body);
  }
  sendZnsByTemplate(body) {
    return this.post('/v2/zalo/zns/send-by-template', body);
  }

  listSms(query?: any) {
    return this.get('/v2/sms', query);
  }
  createSms(body) {
    return this.post('/v2/sms', body);
  }
  updateSms(_id, body) {
    return this.put('/v2/sms/' + _id, body);
  }
  deleteSms(body) {
    return this.post('/v2/sms/deleteMany', body);
  }
  sendSms(body) {
    return this.post('/v2/sms/send', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Social.service.ts